import React from 'react'
import getText from '../strings'
import { LocalizedDate } from '../../application'
import { colors } from '../../styles'
import { Svg } from '../../application'
import styled from 'react-emotion'

const Wrapper = styled('div')`
  .localized-date {
    font-weight: bold;
  }
  >div {
    margin-bottom: 5px;
  }
`

const WithIcon = styled('div')`
  display: flex;
  align-items: center;
  svg.pictogram {
    margin-right: 5px;
  }
`

export default ({ createdtime }) => (
  <Wrapper>
    <h4>{getText('ongoing', 'downloadExtract')}</h4>
    <WithIcon>
      <Svg icon="clock" style={{ color: colors.tui_yellow }} />
      {getText('ongoing', 'extractPrepare')}
    </WithIcon>
    <div>
      {getText('ongoing', 'submitted')}:&nbsp;<LocalizedDate value={createdtime} />
    </div>
    <div>
      {getText('ongoing', 'processTimeForCase')}:&nbsp;<strong>{getText('ongoing', 'processTime')}</strong>
    </div>
  </Wrapper>
)